import { useState, useEffect } from 'react'
import Header from '../../components/Header'
import HeaderImage from '../../images/mission-img.jpg'
import { PassPurchaseModal } from '../../components/BookingComponents'
import './pricing.css'

const Pricing = () => {
  const [showPurchaseModal, setShowPurchaseModal] = useState(false)
  const [selectedPassType, setSelectedPassType] = useState('pass4')
  const [prefill, setPrefill] = useState({ name: '', email: '', justSigned: false })

  const openModal = (passType) => {
    setSelectedPassType(passType)
    setPrefill({ name: '', email: '', justSigned: false })
    setShowPurchaseModal(true)
  }

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const subscribe = params.get('subscribe');
    if (subscribe === 'member2x' || subscribe === 'memberUnl') {
      setSelectedPassType(subscribe);
      setPrefill({ name: params.get('name') ?? '', email: params.get('email') ?? '', justSigned: params.get('signed') === '1' });
      setShowPurchaseModal(true);
      window.history.replaceState(null, '', window.location.pathname);
    }
  }, []);

  return (
    <>
      <Header title="Pricing" image={HeaderImage}>
        Choose the option that fits your practice. No contracts for passes or drop-ins.
      </Header>

      <section className='pricing'>

        <div className='pricing__group container'>
          <div className='pricing__group-header'>
            <p className='pricing__eyebrow'>Group classes</p>
            <h2 className='pricing__section-title'>Passes &amp; memberships</h2>
            <p className='pricing__section-sub'>All passes valid for in-person and online classes.</p>
          </div>
          <div className='pricing__grid'>

            <div className='pricing-card'>
              <p className='pricing-card__label'>Most popular</p>
              <h3 className='pricing-card__title'>4-class pass</h3>
              <p className='pricing-card__body'>Valid for 60 days from purchase. In-person and online.</p>
              <p className='pricing-card__price'>$84</p>
              <button type='button' className='pricing-card__btn' onClick={() => openModal('pass4')}>Buy pass →</button>
            </div>

            <div className='pricing-card'>
              <p className='pricing-card__label'>Best value</p>
              <h3 className='pricing-card__title'>8-class pass</h3>
              <p className='pricing-card__body'>Valid for 90 days from purchase. In-person and online.</p>
              <p className='pricing-card__price'>$152</p>
              <button type='button' className='pricing-card__btn' onClick={() => openModal('pass8')}>Buy pass →</button>
            </div>

            <div className='pricing-card pricing-card--dark'>
              <p className='pricing-card__label'>Committed practice</p>
              <h3 className='pricing-card__title'>Committed membership</h3>
              <p className='pricing-card__body'>2 classes per week. Monthly rolling, no contract.</p>
              <p className='pricing-card__price'>$129/mo</p>
              <button type='button' className='pricing-card__btn' onClick={() => openModal('member2x')}>Subscribe →</button>
            </div>

            <div className='pricing-card pricing-card--dark'>
              <p className='pricing-card__label'>Unlimited</p>
              <h3 className='pricing-card__title'>Unlimited membership</h3>
              <p className='pricing-card__body'>Attend as many classes as you like. Monthly rolling, no contract.</p>
              <p className='pricing-card__price'>$169/mo</p>
              <button type='button' className='pricing-card__btn' onClick={() => openModal('memberUnl')}>Subscribe →</button>
            </div>

            <div className='pricing-card'>
              <p className='pricing-card__label'>Flexible</p>
              <h3 className='pricing-card__title'>Drop-in</h3>
              <p className='pricing-card__body'>No commitment. Pay for a single class any time.</p>
              <p className='pricing-card__price'>$26</p>
              <button type='button' className='pricing-card__btn' onClick={() => openModal('dropin')}>Book now →</button>
            </div>

          </div>
        </div>

        <div className='pricing__private container'>
          <div className='pricing__group-header'>
            <p className='pricing__eyebrow'>One-to-one</p>
            <h2 className='pricing__section-title'>Private classes</h2>
            <p className='pricing__section-sub'>Sessions with Tricia, tailored entirely to you.</p>
          </div>
          <table className='pricing__private-table'>
            <thead>
              <tr>
                <th>Package</th>
                <th>Duration</th>
                <th>Price</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>1 class</td>
                <td>1.5 hr</td>
                <td>$129</td>
                <td><a href='https://buy.stripe.com/dRm6oI3n50V8fqa0l5bMQ00' className='pricing__private-link' target='_blank' rel='noreferrer'>Pay by card</a></td>
              </tr>
              <tr>
                <td>3 classes</td>
                <td>1.5 hr each</td>
                <td>$387</td>
                <td><a href='https://buy.stripe.com/4gM3cwaPx0V8di2d7RbMQ01' className='pricing__private-link' target='_blank' rel='noreferrer'>Pay by card</a></td>
              </tr>
              <tr>
                <td>3 classes</td>
                <td>1 hr each</td>
                <td>$324</td>
                <td><a href='https://buy.stripe.com/00w00kg9eLY2DoffZbMQ03' className='pricing__private-link' target='_blank' rel='noreferrer'>Pay by card</a></td>
              </tr>
              <tr>
                <td>10 classes</td>
                <td>1 hr each</td>
                <td>$880</td>
                <td><a href='https://buy.stripe.com/cNi00k2j19rE1zk6JtbMQ02' className='pricing__private-link' target='_blank' rel='noreferrer'>Pay by card</a></td>
              </tr>
            </tbody>
          </table>
          <p className='pricing__private-note'>
            Card payments include a small processing fee. To pay via Zelle, Venmo, or cash, contact us.
          </p>
          <a href='mailto:info@iy-sp.com' className='pricing__private-btn'>
            Contact us to book
          </a>
        </div>

      </section>

      {showPurchaseModal && (
        <PassPurchaseModal
          onClose={() => setShowPurchaseModal(false)}
          prefillPassType={selectedPassType}
          prefillName={prefill.name}
          prefillEmail={prefill.email}
          justSigned={prefill.justSigned}
        />
      )}
          {/* onClose={() => setShowPurchaseModal(false)}
          prefillPassType={selectedPassType}
        />
      )} */}
    </>
  )
}

export default Pricing
